import {
  API_URL
} from 'api/constants'
export const CHECK_TOKEN_FEEDBACK_URL = `${API_URL}/v1/customers/check_feedback_token`
export const SEND_FEEDBACK_REPLY_FORM = `${API_URL}/v1/customers/reply_feedback_to_business`
export function GET_FEEDBACK_REPLY_FORM (feedbackId) { return (`${API_URL}/v1/customer_feedbacks/${feedbackId}/feedback_messages`) }



// WEBPACK FOOTER //
// ./app/api/feedbackReplyForm/constants.js